// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"174":"c6972e6d","352":"95e16a7f","741":"181d8e6b"}[chunkId] + ".chunk.css";
};